import React from 'react'

type Props = {
  width: string | number
  height: string | number
  fill?: string
}

const IconClose = ({ width, height, fill = '#1e1e23' }: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.36302 4.36358C4.01155 4.71505 4.01155 5.2849 4.36302 5.63637L18.363 19.6364C18.7145 19.9878 19.2843 19.9878 19.6358 19.6364C19.9873 19.2849 19.9873 18.7151 19.6358 18.3636L5.63581 4.36358C5.28434 4.01211 4.71449 4.01211 4.36302 4.36358Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.636 4.36358C19.9875 4.71505 19.9875 5.2849 19.636 5.63637L5.63601 19.6364C5.28453 19.9878 4.71469 19.9878 4.36321 19.6364C4.01174 19.2849 4.01174 18.7151 4.36321 18.3636L18.3632 4.36358C18.7147 4.01211 19.2845 4.01211 19.636 4.36358Z"
        fill={fill}
      />
    </svg>
  )
}

export default IconClose
